import { logger } from '@/core/logger';
import { asyncStorage } from '@/core/storage/asyncStorage';
import { passcodeStorage } from '@/core/storage/passcodeStorage';
import { secureStorage } from '@/core/storage/secureStorage';

/** AsyncStorage is wiped on uninstall. iOS Keychain is not. */
const HAS_LAUNCHED_KEY = 'app.hasLaunched';

const KEYCHAIN_AUTH_KEYS = [
    'auth.secrets',
    'app.auth.secrets',
    'adha_uae_pass_native_resume',
] as const;

/**
 * After reinstall, a leftover iOS Keychain JWT hydrates as logged-in
 * (no user), so Login skips sign-in and opens empty home ("User!", 0).
 */
export async function clearStaleKeychainOnFreshInstall(): Promise<void> {
    try {
        const hasLaunched = await asyncStorage.getItem(HAS_LAUNCHED_KEY);
        if (hasLaunched) {
            return;
        }

        logger.info('FreshInstall:First launch after install — clearing leftover Keychain auth');
        await Promise.all([
            ...KEYCHAIN_AUTH_KEYS.map((key) =>
                secureStorage.removeItem(key).catch(() => undefined),
            ),
            passcodeStorage.clearPasscodeState().catch(() => undefined),
        ]);
        await asyncStorage.setItem(HAS_LAUNCHED_KEY, 'true');
    } catch (error) {
        logger.error('FreshInstall:Failed to clear leftover Keychain auth', error);
    }
}
